export default __webpack_public_path__ + "static/media/calendar.9ef5ffb6.svg";